export default __webpack_public_path__ + "static/media/express.06bc225c.png";